import { useQuery } from "@tanstack/react-query";
import type { MarketplaceAccountsResponse } from "@cx/contracts";
import { useSession } from "../../session";

/** Contas de todos os marketplaces da empresa e o modo de cada provedor no ambiente (sandbox/live/disabled). */
export function useMarketplaceAccounts() {
  const { companyId, api } = useSession();
  return useQuery({
    queryKey: ["marketplace-accounts", companyId],
    queryFn: () => api<MarketplaceAccountsResponse>("/marketplaces/accounts"),
  });
}
